export const Textarea = {
  baseStyle: {
    fontFamily: 'body',
    borderRadius: '7px',
  },
  variants: {
    outline: {
      bg: 'bg.primary',
      borderColor: 'border.primary',
      _placeholder: {
        color: 'var(--chakra-colors-text-muted) !important',
      },
      _invalid: {
        borderColor: 'error.500',
        boxShadow: '0 0 0 2px var(--chakra-colors-accent-danger)',
      },
      _focus: {
        borderColor: 'accent',
        boxShadow: '0 0 0 2px var(--chakra-colors-accent-subtle)',
        zIndex: 1,
      },
      _disabled: {
        opacity: 1,
        bg: 'var(--chakra-colors-bg-disabled) !important',
        color: 'var(--chakra-colors-text-muted) !important',
      },
    },
  },
  sizes: {
    md: {
      fontSize: ['16px', 'sm'],
      px: '2',
    },
    lg: {
      px: '4',
      h: '52px',
      fontSize: ['16px', 'sm'],
    },
  },
};
